import React from "react";
import { Button, Stack, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import AllTable from "./table";
import { LoadingButton } from "@mui/lab";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import FilterIcon from "src/assets/svg-icons/aggregators/filter.svg";
import SelectCountBranch from "./count-branch-popup";
import ImportCountPopup from "./import-count-popup";
import { InventoryPermissions } from "src/constants/permissions";
import { oneBranchHasPermission } from "src/utils";

const All = () => {
  const { t } = useTranslation("inventory");
  const [open, setOpen] = React.useState(false);
  const [openImport, setOpenImport] = React.useState(false);

  // permissions
  const addPermission = oneBranchHasPermission(
    InventoryPermissions.addStocktaking
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenImport = () => setOpenImport(true);
  const handleCloseImport = () => setOpenImport(false);

  return (
    <Stack spacing={1.5}>
      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        spacing={2}
      >
        <Button
          color="tertiary"
          variant="outlined"
          size="small"
          endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
          sx={{ height: "40px" }}
        >
          {t("filter")}
        </Button>

        <Box sx={{ minWidth: 114 }}>
          <LoadingButton
            color="tertiary"
            variant="outlined"
            endIcon={<img src={DownloadIcon} alt="" />}
          >
            {t("download")}
          </LoadingButton>
        </Box>

        {addPermission && (
          <>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpenImport}
            >
              {t("importStocktaking")}
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpen}
            >
              {t("addStocktaking")}
            </Button>
          </>
        )}
      </Stack>
      <AllTable />

      <SelectCountBranch open={open} handleClose={handleClose} />
      {openImport ? (
        <ImportCountPopup open={openImport} handleClose={handleCloseImport} />
      ) : null}
    </Stack>
  );
};

export default All;
